function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "rename",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,1 L0,21.7 L15.2,21.7 L15.2,1 C15.2,0.4 14.8,0 14.2,0 L1,0 C0.4,0 0,0.4 0,1 Z M14.1,20.4 L1.2,20.4 L1.2,11.9 L14.1,11.9 L14.1,20.4 Z M14.1,10.4 L1.2,10.4 L1.2,1.4 L14.1,1.4 L14.1,10.4 Z M9.8,2.6 L8.7,2.6 L8.7,3.7 L6.5,3.7 L6.5,2.6 L5.4,2.6 L5.4,3.8 C5.4,4.4 5.8,4.8 6.4,4.8 L8.7,4.8 C9.3,4.8 9.7,4.4 9.7,3.8 L9.7,2.6 L9.8,2.6 Z M9.8,13 L8.7,13 L8.7,14.1 L6.5,14.1 L6.5,13 L5.4,13 L5.4,14.2 C5.4,14.8 5.8,15.2 6.4,15.2 L8.7,15.2 C9.3,15.2 9.7,14.8 9.7,14.2 L9.7,13 L9.8,13 Z",
  id: "storage-svg-icon"
})));

function SvgStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "22px",
    viewBox: "0 0 16 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Storage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.8eaf5acc.svg";
export { ForwardRef as ReactComponent };